module.exports = __webpack_public_path__ + "../resources/img/ic_rain_snow_weather.84653e48.svg";